import { render } from "./CategoryEditComponent.vue?vue&type=template&id=796dbd51"
import script from "./CategoryEditComponent.vue?vue&type=script&lang=js"
export * from "./CategoryEditComponent.vue?vue&type=script&lang=js"

import "./CategoryEditComponent.vue?vue&type=style&index=0&id=796dbd51&lang=css"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__